(function () {
    'use strict';

    angular.module('thankview.global')
        .directive('flashWarning', function () {
            return {
                restrict: 'E',
                scope: true,
                templateUrl: '/templates/account/flash-warning.html?v=' + config.version,
                link: function (scope) {
                    scope.flashWarning = true;

                    scope.toggleFlashWarning = function () {
                        scope.flashWarning = false;
                    };
                },
            };
        });
}());
